<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MIT -->
<div [class]="avatarClasses()">
  @if (showImage()) {
    <img
      [class]="imageTwClasses()"
      [src]="effectiveImageUrl()"
      [alt]="name() || 'Avatar'"
      (error)="onImageError()"
      (load)="onImageLoad()"
    />
  } @else if (showInitials()) {
    <span [class]="initialsClasses()">{{ initials() }}</span>
  } @else {
    <img [class]="placeholderClasses()" [src]="placeholderSvg()" alt="Placeholder" />
  }
</div>
